import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import FooterLinks from 'PointOfSale/modules/common/component/FooterLinks';
import * as groupActions from 'PointOfSale/modules/group/state/actions';
import { POS_ROUTES } from 'PointOfSale/modules/common/constants';

class GroupProfileFooterContainer extends Component {
  onAccountClicked = () => {
    this.props.groupActions.account();
    this.props.history.push(POS_ROUTES.GROUP);
  };

  render() {
    return (
      <FooterLinks
        options={[
          {
            type: 'Account',
            isDisabled: false,
          },
        ]}
        onClickHandler={this.onAccountClicked}
      />
    );
  }
}

GroupProfileFooterContainer.propTypes = {
  groupActions: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  groupActions: bindActionCreators(groupActions, dispatch),
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(GroupProfileFooterContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/GroupProfileFooterContainer.js